import { NavLink } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { LogOut } from "lucide-react";
import { navigationConfig } from "./navConfig";
import { NavItems } from "./NavItems";

export function Sidebar() {
	const { instance } = useMsal();

	return (
		<aside
			aria-label="Main navigation"
			className="hidden xl:flex xl:w-[280px] xl:flex-col xl:fixed xl:inset-y-0 xl:left-0 xl:border-r xl:border-border xl:bg-background"
		>
			{/* Logo */}
			<div className="flex h-16 items-center px-6">
				<NavLink to="/" className="flex items-center">
					<img src="/mee-logo.svg" alt="Mee" className="h-6" />
				</NavLink>
			</div>

			{/* Navigation */}
			<div className="flex-1 overflow-y-auto px-4 py-4">
				<NavItems items={navigationConfig} />
			</div>

			{/* Sign out */}
			<div className="border-t border-border px-4 py-4">
				<button
					onClick={() => instance.logoutRedirect()}
					className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-muted-foreground transition-all duration-150 hover:bg-accent hover:text-foreground active:scale-[0.98]"
				>
					<LogOut className="h-5 w-5 shrink-0" aria-hidden="true" />
					<span>Sign out</span>
				</button>
			</div>
		</aside>
	);
}
